import { Component, OnInit } from '@angular/core';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb, GenerateTableColumn, GenerateTablePagination } from 'src/app/shared/components';
import { RelatorioService } from '../relatorio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContratoService } from 'src/app/contrato';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { catchErr } from 'src/app/shared/utils';

interface DioEncerradoAutomaticamente {
  prefixo: string;
  quantidade: number;
}

@Component({
  selector: 'app-relatorio-dios-encerrados-automaticamente',
  templateUrl: './relatorio-dios-encerrados-automaticamente.component.html',
  styleUrls: ['./relatorio-dios-encerrados-automaticamente.component.css'],
  standalone: false
})
export class RelatorioDiosEncerradosAutomaticamenteComponent extends GenericRelatorioComponent implements OnInit {
  
  breadcrumb: Breadcrumb[] = [
    { label: 'Início' },
    { label: 'Relatórios', route: '/relatorio' },
    { label: 'DIOs Encerrados Automaticamente' },
  ]

  dataSource: DioEncerradoAutomaticamente[] = [];
  pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
  columns: GenerateTableColumn[] = [
    { header: '#', attr: 'index' },
    { header: 'Prefixo', attr: 'prefixo' },
    { header: 'Quantidade de DIOs', attr: 'quantidade' }
  ];

  constructor(
    private relatorioService: RelatorioService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {
    super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    const hoje = new Date();
    this.filters.dataInicio = hoje.toISOString().split('T')[0];
    this.filters.dataFim = hoje.toISOString().split('T')[0];
    this.toggleFilters = true;
  }

  setBeneficiaria(beneficiaria: Beneficiaria) {
    this.filters.contrato = undefined;
    if (beneficiaria?.id) {
      this.buscaContratos(beneficiaria.id);
    } else {
      this.contratos = [];
    }
  }

  search() {
    if (!this.filters.dataInicio || !this.filters.dataFim) {
      this.snackBar.open('Selecione o período', '✕', { panelClass: ['warning'] });
      return;
    }

    this.loading = true;

    // Formatar datas para yyyy-MM-dd
    const formatDate = (date: any): string => {
      if (!date) return '';
      if (typeof date === 'string') return date;
      return new Date(date).toISOString().split('T')[0];
    };

    const params = {
      dataInicio: formatDate(this.filters.dataInicio),
      dataFim: formatDate(this.filters.dataFim),
      beneficiaria: (this.filters.beneficiaria as any)?.id || (this.filters.beneficiaria as any),
      contrato: (this.filters.contrato as any)?.id || this.filters.contrato
    };

    this.relatorioService.getRelatorioDiosEncerradosAutomaticamente(params).subscribe({
      next: (res: any) => {
        if (res.report?.data) {
          this.dataSource = res.report.data.map((item: any, index: number) => ({
            index: index + 1,
            prefixo: item.prefixo,
            quantidade: item.quantidadeDios
          }));
          this.pagination.total = parseInt(res.report.total) || res.report.data.length;
        } else {
          this.dataSource = [];
          this.pagination.total = 0;
        }
      },
      error: (err) => catchErr(err, this.snackBar)
    }).add(() => this.loading = false);
  }

}
